
import { Component, Vue } from 'vue-property-decorator';
@Component({
  name: 'BlackTip',
})
class BlackTip extends Vue {
  visible:boolean = false;
  msgText:string  =  '';
  maxWidth: number = 240;
}
export default BlackTip;
